import React from 'react';
import { connect } from 'react-redux';

import { Element } from '@americanexpress/aqx-components';
import AutoSlidingCarousel from './components/AutoSlidingCarousel';

// selectors
import { getStackedCarouselData } from 'page_modules/business-pdp/redux';

import styles from './__styles__/index.scss?modules';

export const CarouselStackedBenefits = ({ data }) => {
  if (!data) {
    return null;
  }

  return (
    <Element className={styles.CarouselStackedBenefits}>
      <AutoSlidingCarousel contentList={data} />
    </Element>
  );
};

const mapStateToProps = state => ({
  data: getStackedCarouselData(state)
});

export default connect(mapStateToProps)(React.memo(CarouselStackedBenefits));
